module.exports = __webpack_public_path__ + "media/assets/images/blog/pexels-ksenia-kartasheva-small-55f52963f6254375f13a676dda549710.jpg";